<template>
    <div class="sticky-top">
        <div class="container-fluid">
            <!-- Sidebar -->
            <div class="sidebar">
                <img :src="getImagePath(localSettings?.logo)" class="h-8 mr-1"
                    height="50" width="141"
                    :alt="`${localSettings?.website_name} Logo`" 
                    :title="`${localSettings?.website_name} Logo`"/>
                <hr>
                <section class="offcanvas-body" v-for="category in selectedCategories" :key="category.id"
                    :aria-labelledby="'categoryLabel' + category.id">
                    <button class="category-dropdown w-100" type="button" data-bs-toggle="collapse"
                            :data-bs-target="'#menuItems' + category.id" aria-expanded="false"
                            :aria-label="`Toggle subcategories for ${category.name}`"
                            :id="'categoryLabel' + category.id"
                            :aria-controls="'menuItems' + category.id" style="position: relative;">
                        {{ category.name }}

                        <i class="fas fa-angle-down position" aria-hidden="true"></i>
                    </button>

                    <!-- Collapsible Items inside Drawer -->
                    <div class="collapse" :id="'menuItems' + category.id"
                            role="region"
                            :aria-labelledby="'categoryLabel' + category.id">
                        <div class="list-group">
                            <router-link
                                v-for="subcategory in getSubcategories(category.id)"
                                :key="subcategory.id"
                                class="dropdown-item"
                                :aria-label="`Go to ${subcategory.name} in ${category.name}`"
                                :to="{ name: 'category', params: { category: category.slug, sub_category: subcategory.slug } }">
                                <i :class="subcategory.icon_picker" class="mr-2" aria-hidden="true"></i>{{ subcategory.name }}
                            </router-link>
                        </div>
                    </div>
                </section>

                <nav aria-label="Main navigation">
                    <ul class="list-unstyled m-0">
                        

                        <li class="p-2">
                        <router-link to="/write_review" aria-label="Write a business review" class="default-color">Write a Review</router-link>
                        </li>
                        <li class="p-2">
                        <a href="/register" aria-label="Register to start writing blogs" class="default-color">Start Writing</a>
                        </li>

                        <li class="p-2">
                        <router-link to="/contact-us" aria-label="Contact our team" class="default-color">Contact Us</router-link>
                        </li>

                        <li class="p-2">
                        <router-link to="/blogs" aria-label="Read our latest blogs" class="default-color">Blogs</router-link>
                        </li>
<li class="p-2">
                        <router-link to="/pricing" aria-label="Add your business listing" class="default-color">Add Business</router-link>
                        </li>
                        <li class="p-2">
                        <router-link to="/claim_business" aria-label="Claim ownership of your business listing" class="default-color">Claim Your Business</router-link>
                        </li>


                        <li class="p-2">
                        <a href="/login" aria-label="Log in to your business account" class="default-color">Log in to Business Account</a>
                        </li>
                    </ul>
                </nav>

            </div>

            <!-- Overlay -->
            <div class="overlay"></div>

            <nav class="navbar navbar-expand-lg">

                <div class="container-fluid header" style="margin-top: -26px;">
                    <!-- Navbar Brand -->
                    <a class="navbar-brand mx-0 ms-lg-3 me-lg-4" href="/">
                        <img height="50" width="141" 
                            :src="getImagePath(localSettings?.logo)" class="h-8 mr-1"
                            :alt="`${localSettings?.website_name} Logo`" 
                            :title="`${localSettings?.website_name} Logo`"/>
                    </a>

                    <button
                        class="navbar-toggler1"
                        type="button"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#offcanvasExample"
                        aria-controls="offcanvasExample"
                        aria-label="Toggle navigation menu"
                        aria-expanded="false"
                        >
                        <span class="navbar-toggler-icon" aria-hidden="true"></span>
                    </button>

                    <!-- Navbar items -->
                     <!-- justify-content-between on mobile it will be justify-content-start -->
                    <div class="collapse navbar-collapse justify-content-between flex-wrap"
                     id="navbarSupportedContent">
                        <div class="navbar-nav main-input-plus-nav" style="width: 60% !important; margin-top: 39px;">
                            <!-- Search Inputs -->
                            <form class="custom-form-input">
                                <div class="input-group custom-input-group">
                                    <!-- Search Business Input -->
                                    <div style="flex: 2; position: relative;">
                                        <input 
                                            type="text" 
                                            v-model="searchQuery" 
                                            class="form-control dropdown-toggle"
                                            id="dropdownMenuButton1" 
                                            role="combobox"
                                            aria-label="Search business categories"
                                            aria-autocomplete="list"
                                            aria-expanded="false"
                                            aria-controls="custom-dropdown-menu"
                                            data-bs-toggle="dropdown"
                                            placeholder="Search Business Category"
                                            autocomplete="off"
                                            @focus="searchExpanded = true"
                                            @blur="searchExpanded = false">

                                        <ul 
                                            id="custom-dropdown-menu" 
                                            class="dropdown-menu custom-dropdown-menu sraech"
                                            role="listbox"
                                            :aria-hidden="!searchExpanded">
                                            <li v-for="item in displayedItems" 
                                                :key="item.slug"
                                                role="option">
                                                <button class="dropdown-item" 
                                                type="button"
                                                @click="selectSubcategory(item)"
                                                tabindex="0">
                                                    <i class="fa fa-list-alt mr-1" aria-hidden="true"></i>{{ item.name }}
                                                </button>
                                            </li>
                                            <li v-if="displayedItems.length === 0" role="option">
                                                <img style="width:100%; height: 180px" 
                                                    src="/svg/searching-data.svg" 
                                                    alt="No search results found" 
                                                    title="Search Data">
                                                <p class="text-center">Search Any Business Type</p>
                                            </li>
                                        </ul>
                                    </div>

                                    <!-- Location Input -->
                                    <div style="flex: 1.5; position: relative;">
                                        <input 
                                            type="text" 
                                            v-model="country_name" 
                                            class="form-control dropdown-toggle"
                                            id="dropdownMenuButton2" 
                                            role="combobox"
                                            aria-label="Select location"
                                            aria-autocomplete="list"
                                            aria-expanded="false"
                                            aria-controls="custom-dropdown-menu2"
                                            data-bs-toggle="dropdown"
                                            :placeholder="`${location.city}, ${location.country_name}`"
                                            autocomplete="off"
                                            @focus="locationExpanded = true"
                                            @blur="locationExpanded = false">

                                        <ul 
                                            id="custom-dropdown-menu2" 
                                            class="dropdown-menu custom-dropdown-menu1"
                                            role="listbox"
                                            :aria-hidden="!locationExpanded">
                                            <li v-for="location in filteredCountries" 
                                                :key="location.id"
                                                role="option">
                                                <button 
                                                    class="dropdown-item" 
                                                    type="button" 
                                                    @click="handleLocationSelection(location.name, location.id, location.slug)"
                                                    tabindex="0">
                                                    <i class="fas fa-map-marker-alt mr-1" aria-hidden="true"></i>{{ location.name }}
                                                </button>
                                            </li>
                                        </ul>
                                    </div>

                                    <button 
                                        class="btn btn-primary" 
                                        type="button" 
                                        @click="navigateToSubcategory"
                                        aria-label="Search for businesses">
                                        <i class="fa fa-search" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </form>
                            <div class="collapse navbar-collapse" id="navbarNav">
                                <ul class="navbar-nav mt-2">
                                    <li v-if="selectedCategories.length > 0" class="nav-item dropdown" v-for="category in selectedCategories"
                                        :key="category.id">
                                        <a class="nav-link dropdown-toggle" href="" 
                                            :id="`navbarDropdown${category.name}`" role="button"
                                           data-bs-toggle="dropdown" aria-expanded="false">
                                            {{ category.name }}
                                        </a>

                                        <ul class="dropdown-menu two-column w-auto"
                                            :aria-labelledby="`navbarDropdown${category.name}`">
                                            <li v-for="subcategory in getSubcategories(category.id)"
                                                :key="subcategory.id">
                                                <router-link class="dropdown-item"
                                                             :to="{ name: 'category', params: { category: category.slug, sub_category: subcategory.slug, } }">
                                                    <i :class="subcategory.icon_picker"></i> {{ subcategory.name }}
                                                </router-link>
                                            </li>
                                        </ul>
                                    </li>
                                    <li v-else class="nav-item dropdown">
                                        <a class="nav-link">
                                            Popular Categories
                                        </a>
                                    </li>
                                </ul>

                            </div>
                        </div>
                        <ul class="navbar-nav">
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="" id="navbarDropdown" role="button"
                                   data-bs-toggle="dropdown" aria-expanded="false">
                                    For Business
                                </a>
                                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <li>
                                        <router-link class="dropdown-item" to="/pricing"><i class="fas fa-home"></i> Add
                                            a Business
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link class="dropdown-item" to="/claim_business">
                                            <i class="fas fa-user"></i> Claim Your Business
                                        </router-link>
                                    </li>

                                    <li><a class="dropdown-item" target="_blank" href="/login"><i class="fas fa-cog"></i> Log in to Business
                                        Account</a></li>
                                    <hr>
                                    <li>
                                        <router-link class="dropdown-item" to="/business-explore">
                                            <i class="fas fa-envelope"></i> Explore Business
                                        </router-link>
                                    </li>
                                </ul>
                            </li>
                            <li class="nav-item">
                             <router-link class="dropdown-item" to="/write_review" style="padding:7px !important;">
                                 Write a Review
                             </router-link>
                            </li>

                            <li class="nav-item d-flex align-items-center">
                                <router-link class="icon-btn" to="/favorite" aria-label="Favorites">
                                    <i class="fas fa-heart" aria-hidden="true"></i>
                                    <span class="icon-badge" v-if="FavItemsCount > 0">{{ FavItemsCount }}</span>
                                </router-link>
                            </li>

                            <li class="nav-item d-flex align-items-center">
                                <router-link class="icon-btn" to="/cart" aria-label="Shopping Cart">
                                    <i class="fas fa-shopping-cart" aria-hidden="true"></i>
                                    <span class="icon-badge" v-if="cartItems && cartItems.count > 0">{{ cartItems.count }}</span>
                                </router-link>
                            </li>
                        </ul>
<div class="navbar-nav auth-section">
    <!-- Logged In User -->
    <div v-if="isAuthenticated" class="nav-item dropdown user-dropdown">
        <a 
            class="nav-link dropdown-toggle d-flex align-items-center gap-2" 
            href="#" 
            id="userDropdown"
            role="button" 
            data-bs-toggle="dropdown" 
            aria-expanded="false">
            
            <div class="user-avatar">
                <img 
                    :src="getUserImage" 
                    alt="User Profile"
                    class="rounded-circle"
                >
            </div>
            
            <div class="user-info d-none d-lg-block">
                <span class="user-name">{{ user?.first_name }} {{ user?.last_name }}</span>
            </div>
        </a>

        <ul class="dropdown-menu dropdown-menu-end shadow-sm" aria-labelledby="userDropdown">
            <li>
                <router-link class="dropdown-item" to="/dashboard">
                    <i class="fas fa-tachometer-alt me-2"></i> Dashboard
                </router-link>
            </li>
            <li>
                <router-link class="dropdown-item" to="/profile">
                    <i class="fas fa-user me-2"></i> My Profile
                </router-link>
            </li>
            <li><hr class="dropdown-divider"></li>
            <li>
                <a class="dropdown-item text-danger" href="#" @click.prevent="logoutUser">
                    <i class="fas fa-sign-out-alt me-2"></i> Sign Out
                </a>
            </li>
        </ul>
    </div>

    <!-- Not Logged In -->
    <div v-else class="nav-item">
        <router-link to="/user/login">
            <button class="btn login-btn">
                <i class="fa fa-sign-in-alt me-2"></i> 
                <span class="d-none d-md-inline">Login</span>
            </button>
        </router-link>
    </div>
</div>
                    </div>

                </div>

            </nav>
        </div>
    </div>
</template>

<script>
import {mapActions, mapState,mapGetters} from 'vuex';
import { toast } from 'vue3-toastify';
import { getImagePath } from '../../utils/helpers';

export default {
    name: "Login",
    data() {
        return {
            country_name: '',
            country_id: 0,
            searchQuery: '',
            selectedSubcategory: null,  // Track the selected subcategory
            localSettings: null,
            searchExpanded: false,
            locationExpanded: false,
            country_slug: '',
        };
    },

    computed: {
        ...mapState('business', ['cartItems','FavItemsCount']),
        ...mapState('auth', ['isAuthenticated', 'token', 'user']),
        ...mapState('home', ['categories', 'settings', 'category_loading', 'subcategories', 'location',]),
        ...mapState('dashboard', ['totalDashboardOrder']),
        ...mapGetters('auth' ,['getUserImage']) ,
        selectedCategories() {
            const selectedIds = [8, 10, 15, 6 ,2,7,11];
            return this.categories.filter(category => selectedIds.includes(category.id));
        },
        displayedItems() {
            if (this.searchQuery) {
                // Show filtered subcategories based on the search query
                return this.subcategories.filter(item =>
                    item.name.toLowerCase().includes(this.searchQuery.toLowerCase())
                );
            } else {
                // Show the first 8 subcategories when no search query is present
                return this.subcategories.slice(0, 0);
            }
        },

        filteredCountries() {
            if (!this.country_name) {
                return this.location.all_countries; // Return all countries if search is empty
            }
            return this.location.all_countries.filter(country =>
                country.name.toLowerCase().includes(this.country_name.toLowerCase())
            );
        },

    },
    methods: {
        ...mapActions('auth', ['getUser', 'logout']),
        ...mapActions('business', ['fetchCartItems','fetchFavItemCount']),
        ...mapActions('home', ['fetchCategories', 'getLocation', 'fetchSettings', 'setLocation']),
        getImagePath,
        logoutUser() {
            this.logout();
            this.$router.push({name: 'home'});
            this.fetchFavItemCount();
        },
        filteredCountries() {
            return this.location.all_countries.filter(country =>
                country.name.toLowerCase().includes(this.country_name.toLowerCase())
            );
        },
        // Select subcategory
        selectSubcategory(subcategory) {
            this.selectedSubcategory = subcategory;
            this.searchQuery = subcategory.name;
        },
        async handleLocationSelection(country_name, country_id, country_slug) {
            await this.setLocation({country_name, country_id});
            this.country_name = country_name;
            this.country_id = country_id;
            this.country_slug = country_slug

        },
        // Navigate to subcategory page
        navigateToSubcategory() {

            if (this.selectedSubcategory && this.country_name) {
                this.$router.push({
                    name: 'category',  // Ensure you have this route defined
                    params: {
                        category: this.selectedSubcategory.category_slug,
                        sub_category: this.selectedSubcategory.slug,
                        country: this.country_slug
                    }
                });
            } else {
                toast.error('Please select both a subcategory and a location.');
            }
        },
        getSubcategories(categoryId) {
            return this.subcategories.filter(subcategory => subcategory.category_id == categoryId).slice(0, 6);
        },
        clearSearchQuery() {
            this.searchQuery = ''; // Clear the search query
        }
    },
    created() {
        this.getUser();
        this.getLocation({
            search: this.country_name
        });
    },
    watch: {
        location: {
            handler(newLocation) {
                if (newLocation) {
                    this.country_name = newLocation.country_name;
                    this.country_id = newLocation.country_id;
                }
            },
            deep: true, // Use deep to watch nested properties if necessary
            immediate: true, // This will trigger the watcher immediately with the current value of location
        },
        settings: {
            handler(newValue) {
                this.localSettings = newValue;
            },
            immediate: true,
        }
    },
    mounted() {
        this.fetchCartItems();
        this.fetchCategories();
        this.fetchFavItemCount();
        this.fetchSettings();
    },
}

document.addEventListener('DOMContentLoaded', function () {
    const overlay = document.querySelector('.overlay');
    const sidebar = document.querySelector('.sidebar');

    document.querySelector('.navbar-toggler1').addEventListener('click', function () {
        overlay.classList.toggle('show');
        sidebar.classList.toggle('show');
    });

    overlay.addEventListener('click', function () {
        overlay.classList.remove('show');
        sidebar.classList.remove('show');
    });
});
</script>
<style scoped>
/* Fixed logo height so the header can't change height when the logo image loads
   (a global img{height:auto} otherwise let it snap from 50px to ~21px, rippling a
   large layout shift down the whole page). Matches the server-rendered .ssr-logo. */
.navbar-brand img {
    height: 44px;
    width: auto;
    max-width: 150px;
    object-fit: contain;
}
@media (max-width: 991px) {
    .navbar-brand img {
        height: 38px;
    }
}

/* ====================== AUTHENTICATION SECTION ====================== */

.auth-section {
    margin-left: auto;
}

.user-dropdown .nav-link {
    padding: 6px 12px;
    border-radius: 50px;
    transition: all 0.3s ease;
}

.user-dropdown .nav-link:hover {
    background-color: rgba(255, 94, 20, 0.08);
}

.user-avatar {
    width: 38px;
    height: 38px;
    border: 2px solid #ff5e14;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
}

.user-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.user-info .user-name {
    font-weight: 600;
    font-size: 15px;
    color: #333;
    white-space: nowrap;
}

/* Login Button - Modern Orange Style */
.login-btn {
    background: linear-gradient(135deg, #ff5e14, #ff7a3f);
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 50px;
    font-weight: 600;
    font-size: 15px;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(255, 94, 20, 0.3);
}

.login-btn:hover {
    background: linear-gradient(135deg, #e04e0f, #ff5e14);
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(255, 94, 20, 0.4);
}

.login-btn i {
    font-size: 16px;
}

/* Dropdown Styling */
.dropdown-menu {
    border: none;
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
    padding: 8px 0;
    min-width: 180px;
}

.dropdown-item {
    padding: 10px 20px;
    font-size: 14.5px;
    color: #444;
    transition: all 0.2s;
}

.dropdown-item:hover {
    background-color: #fff4f0;
    color: #ff5e14;
    padding-left: 24px;
}

.dropdown-divider {
    margin: 6px 0;
    border-color: #eee;
}
.navbar-toggler1{
    padding: 7px 10px;
    border: 1px solid #a2a2a2;
    border-radius: 5px;
    background: white;
}
.position{
    position: absolute;
    top: 7px;
    right: 14px;
}
.category-dropdown {
    width: 100%;
    padding: 4px;
    border-radius: 8px;
    background-color: #ffffff;
    color: black;
    border: 1px solid #d2d2d2;
    margin-bottom: 15px;
    text-align: left;
    padding-left: 12px;
}

.sraech {
    height: 17rem;
    overflow: auto;
}

.main-input-plus-nav {
    display: flex !important;
    flex-direction: column !important;
    margin-top: 10px
}

.nav-item a {
    font-size: 14px;
    font-weight: 400 !important;
    color: #515455 !important;
}

/*.dropdown:hover .dropdown-menu {*/
/*    display: block;*/
/*}*/
.dropdown-menu.two-column {
    width: 400px;
    columns: 2;
    padding-left: 10px !important;
}

.navbar-nav .nav-link.active, .navbar-nav .nav-link.show, .navbar-nav .nav-link:hover {
    color: var(--bs-navbar-active-color) !important;
    /*border-bottom: 2px solid #ff5e1f;*/
}

/* Optional: Adjust the padding and font size of menu items */
.dropdown-item {
    padding: 10px;
    font-size: 14px;
}

/* Optional: Add hover effect */
.dropdown-item:hover {
    background-color: #f8f9fa;
}

.sticky-top {
    position: sticky;
    top: 0;
    z-index: 1000;
    background-color: white;
    border-bottom: 1px solid #ebebeb;
}

.sidebar {
    position: fixed;
    top: 0;
    bottom: 0;
    left: -250px; /* Start hidden */
    z-index: 1000;
    width: 250px;
    padding: 20px;
    background-color: #f8f9fa;
    transition: all 0.3s ease;
}

.sidebar.show {
    left: 0; /* Show sidebar */
}

.overlay {
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    z-index: 999;
    display: none;
}

.overlay.show {
    display: block; /* Show overlay */
}

.custom-input-group {
    display: flex;
}

.custom-input-group .form-control {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    margin: 0px;
    border-color: rgba(235, 235, 235, 1)
}

.custom-input-group .btn {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}

.custom-form-input {
    box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 18px 0px;
    width: 100%
}

.fa-search {
    font-size: 20px;
}

/*dropdown 1*/

.custom-dropdown-menu {
    border: none;
    border-radius: 0;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 18px 0px;
    margin-top: 0px !important;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
}

.custom-dropdown-menu li {
    width: 100%;
}

.custom-dropdown-menu li a {
    display: block;
    width: 100%;
    padding: 0.75rem 1rem;
    color: #616466 !important;
    text-decoration: none;
}

/*dropdown 2*/
.custom-dropdown-menu1 {
    border: none;
    border-radius: 0;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 18px 0px;
    margin-top: 0px !important;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
    max-height: 300px;
    overflow: auto;
    cursor: pointer;
}

.custom-dropdown-menu1 li {
    width: 100%;
}

.custom-dropdown-menu1 li button,
.custom-dropdown-menu li button {
    display: block;
    width: 100%;
    padding: 0.75rem 1rem;
    color: #616466 !important;
    text-decoration: none;
}

.spinner {
    text-align: center;
    width: 202%;
}

/* Favorites / Cart icon buttons: a round hit-target with the count badge tucked
   into the corner (standard notification-badge pattern) instead of the old
   floating span, which sat far above the icon and never lined up between the
   two links. The badge is hidden entirely at 0 — a "0" badge reads as broken. */
.icon-btn {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    color: #515455;
    font-size: 26px;
    transition: background-color 0.15s ease, color 0.15s ease;
}
.icon-btn:hover,
.icon-btn:focus-visible {
    background: #fff4ef;
    color: #ff5e14;
}
.icon-badge {
    position: absolute;
    top: 3px;
    right: 3px;
    min-width: 19px;
    height: 19px;
    padding: 0 5px;
    border-radius: 999px;
    /* deep brand orange: WCAG AA contrast with white text */
    background: #c74800;
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    line-height: 19px;
    text-align: center;
    box-shadow: 0 0 0 2px #fff;
}
.btn-primary {
    background-color: #ff5e1f !important;
    color: white !important;
    border-color: #ff5e1f !important;
}
.default-color{
    color: #ff5e1f !important;
    font-weight: 600;
}
@media only screen and (max-width: 992px) {
    .header {
        margin-top: 0 !important;
    }
}
@media only screen and (max-width: 576px) {
    .header {
        padding: 0 !important;
    }
}
@media (min-width: 992px) {
    .navbar-toggler1 {
        display: none !important;
    }
}
.nevy-button {
    padding: 10px 16px !important;
}

.custom-input-group {
    position: relative;
    display: flex;
}

/* Make dropdown match input width automatically */
.custom-input-group .dropdown-menu {
    width: 100% !important;
    left: 0 !important;
}

/* First dropdown matches first input */
#dropdownMenuButton1 {
    position: relative;
}

#custom-dropdown-menu {
    position: absolute !important;
    top: 100% !important;
    left: 0 !important;
    width: 100% !important;
}

/* Second dropdown matches second input */
#dropdownMenuButton2 {
    position: relative;
}

#custom-dropdown-menu2 {
    position: absolute !important;
    top: 100% !important;
    left: 0 !important;
    width: 100% !important;
}

/* Wrap inputs in relative containers */
.custom-input-group > div {
    position: relative;
    flex: 1;
}
</style>
